export const MENU_VISIBILITY_CONFIG = {
  modules: {
    admin: true,
    pricings: false,
    promotions: true,
    fidelity: false,
    purchaseOrders: false,
    repositionOrders: false,
    commercialAnalysis: false,
  },
  adminMenu: {
    dashboard: false,
    company: true,
    clientValidationStats: true,
    parameters: {
      enabled: true,
      subItems: {
        parameters: true,
        goals: true,
        paymentMethods: true,
        wholesalers: true,
      },
    },
    usersAndRoles: true,
    catalogue: {
      enabled: true,
      subItems: {
        categories: true,
        articles: true,
        attributes: true,
        colours: true,
        suppliers: true,
        brands: true,
        curves: true,
        stockMovements: true,
      },
    },
    branchOffices: {
      enabled: true,
      subItems: {
        branchOffices: true,
        deposits: true,
        clusters: true,
        vehicles: true,
      },
    },
    import: {
      enabled: true,
      subItems: {
        ticketImport: true,
        rewardImport: true,
        stockMovementImport: true,
        pricingImport: true,
        clientImport: true,
        skuImport: true,
        articleSeasonImport: true,
        paymentMethodImport: true,
        promotionImport: true,
        pointsMovementImport: true,
        branchOfficeImport: true,
        purchaseOrderImport: true,
        repositionOrderImport: true,
      },
    },
    dataScienceJobs: true,
  },
  commercialIntelligenceMenu: {
    dashboard: false,
    brightPulse: {
      enabled: true,
      subItems: {
        commercialSummary: true,
        dailyControl: false,
        categoryAnalysis: true,
        productAnalysis: true,
        brandAnalysis: true,
        channelAnalysis: true,
        storeAnalysis: true,
        commercialDateAnalysis: false,
        productMixAnalysis: false,
        clientAnalysis: true,
        promotionAnalysis: false,
        campaignAnalysis: false,
        wholesaleAnalysis: false,
      },
    },
    brightActions: {
      enabled: true,
      subItems: {
        segments: true,
        incentives: true,
        promotions: true,
        activationActions: true,
        campaigns: true,
      },
    },
    brightClub: {
      enabled: true,
      subItems: {
        loyaltyProgramAnalysis: false,
        clientLevels: true,
        units: true,
      },
    },
    similarArticles: true,
    clients: true,
    tickets: true,
    configuration: {
      enabled: true,
      subItems: {
        rewardTypes: true,
        articleGroups: false,
      },
    },
  },
  promotionsMenu: {
    dashboard: true,
    clients: true,
    segments: true,
    clientLevels: true,
    articleGroups: true,
    promotions: true,
    tickets: true,
    campaigns: true,
    statistics: true,
  },
  fidelityMenu: {
    dashboard: true,
    clients: true,
    clientSegments: true,
    clientLevels: true,
    tickets: true,
    recommendations: true,
    rewardTypes: true,
    rewards: true,
    units: true,
  },
  pricingMenu: {
    dashboard: true,
    pricings: true,
    articleGroups: true,
  },
  purchaseOrdersMenu: {
    dashboard: true,
    catalogue: true,
    management: true,
    stockBreaks: true,
    recommendations: true,
  },
  repositionOrdersMenu: {
    dashboard: true,
    catalogue: true,
    management: true,
    stockBreaks: true,
    requests: true,
  },
  commercialAnalysisMenu: {
    commercialSummary: false,
    dailyControl: false,
    categoryAnalysis: true,
    productAnalysis: true,
    brandAnalysis: true,
    channelAnalysis: true,
    storeAnalysis: true,
    commercialDateAnalysis: false,
    productMixAnalysis: false,
    clientAnalysis: true,
    promotionAnalysis: false,
    campaignAnalysis: false,
    loyaltyProgramAnalysis: false,
    wholesaleAnalysis: false,
  },
};

